// ** React Imports
import { useState, useEffect, useRef, Fragment } from 'react'
import { ChevronDown } from 'react-feather'
import { useSelector, useDispatch } from "react-redux"
import { Button, UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from "reactstrap"
import { setShowHideMenuData } from '../../../../views/redux/store'
import { useLocation } from 'react-router-dom'
const NavbarDropdown = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const stores = useSelector((state) => state.commonreducerSlice)
  const [open, setOpen] = useState(false)
  const [openClick, setOpenClick] = useState(false)
  const container = useRef(null)
  const [catData, setCatData] = useState([])
  const [catValue, setCatValue] = useState(4)
  const [catName, setCatName] = useState('Publications')

  useEffect(() => {
    setCatData(stores.woCates)
    const woCatObj = localStorage.getItem('catObj') ? JSON.parse(localStorage.getItem('catObj')) : ''
    if (woCatObj) {
      setCatValue(woCatObj.value)
      setCatName(woCatObj.label)
    }
  }, [stores.woCates.length])

  useEffect(() => {
    if (catName === 'Publications' && location.pathname === '/dashboard') {
      dispatch(setShowHideMenuData(true))
    } else {
      dispatch(setShowHideMenuData(false))
    }
  }, [catName])

  const handleClickOutside = event => {
    if (container.current && !container.current.contains(event.target)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      // clean up
      document.removeEventListener("mousedown", handleClickOutside)
    }
  })

  const handleMouseEnter = () => {
    setOpen(true)
  }

  const handleMouseLeave = () => {
    setOpen(false)
  }

  return (
    <Fragment>
      <UncontrolledDropdown tag="li" className={`dropdown-user nav-item dropdown-cat dropdown_dashboard_user`}
        onMouseLeave={handleMouseLeave}
        style={{ paddingTop: 0, border: 0 }}>
        <DropdownToggle
          href="/"
          tag="a"
          className="nav-link dropdown-user-link navbar_dropdown"
          onClick={(e) => {
            e.preventDefault() 
            setOpenClick(!openClick)
          }}
          style={{ border: open ? '1px solid #157387' : '0px solid #ededed', padding: '5px' }}
          onMouseEnter={handleMouseEnter}
        >
          <span className='span' style={{ fontWeight: '500', color: '#262626', fontSize: '16px' }}> {catName} </span>
          <button type="button" style={{ border: 'none', background: 'none', float: 'right' }}>
            <ChevronDown size={24} />
          </button>
        </DropdownToggle>
        <DropdownMenu end
          className={open ? (openClick ? 'show cat_dropdown_click' : 'show cat_dropdown_show') : 'hide cat_dropdown_show'}
        >
          {catData.map((item, index) => {
            return (
              <DropdownItem key={index}
                onClick={() => {
                  setOpen(!open)
                  setCatValue(item.value)
                  setCatName(item.label)
                  localStorage.setItem('catObj', JSON.stringify(item))
                  localStorage.setItem('searchCategory', item ? item.value : '')
                  localStorage.setItem('typeObj', null)
                  localStorage.setItem('searchType', '')
                  localStorage.setItem('stageObj', null)
                  localStorage.setItem('searchStage', '')
                }}>
                <span className="align-middle">{item.label}</span>
              </DropdownItem>
            )
          })}
        </DropdownMenu>
      </UncontrolledDropdown>

      <div className='float-left navbar_dropdown d-none'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ border: open ? '1px solid #157387' : '0px solid #ededed' }}
      >
        <div onClick={() => setOpen(!open)} >
          <span className='span' style={{ fontWeight: '500', color: '#262626', fontSize: '16px' }}> {catName} </span>
          <button type="button" style={{ border: 'none', background: 'none', float: 'right' }}>
            <ChevronDown size={24} style={{ marginBottom: '4px' }} />
          </button>
          {open && (
            <div className="dropdown-wrapper-db" style={{ marginTop: catName ? '13px' : '40px', left: '224px', marginLeft: 0 }}>
              <ul className="dropdown-menu-db">
                {catData.map((item) => (
                  <li
                    className={catValue === item.value ? "dropdown-menu-db__select" : "dropdown-menu-db__item"} key={item.value}
                    onClick={() => {
                      setOpen(!open)
                      setCatValue(item.value)
                      setCatName(item.label)
                      localStorage.setItem('catObj', JSON.stringify(item))
                      localStorage.setItem('searchCategory', item ? item.value : '')
                      localStorage.setItem('typeObj', null)
                      localStorage.setItem('searchType', '')
                      localStorage.setItem('stageObj', null)
                      localStorage.setItem('searchStage', '')
                    }
                    }>{item.label}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  )
}

export default NavbarDropdown